import React from "react"
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap"

function OperatorManagerProductsModal(props) {
  const { isOpen, toggle, operatorManagerProducts } = props

  return (
    <>
      <Modal
        isOpen={isOpen}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        tabIndex="-1"
        toggle={toggle}
      >
        <div className="modal-content">
          <ModalHeader toggle={toggle}>Product Details</ModalHeader>
          <ModalBody>
            <div className="table-responsive">
              <Table className="table align-middle table-nowrap">
                <thead>
                  <tr>
                    <th scope="col">Product#</th>
                    <th scope="col">Product Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{operatorManagerProducts?.product_id}</td>
                    <td>{operatorManagerProducts?.product.name}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" onClick={toggle}>
              Close
            </Button>
          </ModalFooter>
        </div>
      </Modal>
    </>
  )
}

export default OperatorManagerProductsModal
